/*******************************************************************************
* @ngdoc    service
* @name     csm.books.InitialSetup.services.service:SetupServices
* @description
* Base setup application controller services.
*******************************************************************************/
/* @ngInject */ export function SetupServicesProvider($injector) {
  /**
   * @ngdoc property
   * @name  SetupServicesProvider#httpServiceBase
   * @description
   * Server side controller URL.
   */
  this.httpServiceBase = '/books/initialSetup/';

  /**
   * @ngdoc property
   * @name  SetupServicesProvider#httpServices
   * @description
   * Server side service methods.
   */
  this.httpServices = {
    importAccounts: function () {
      return this.post('importAccounts');
    },
    importPendingItems: function () {
      return this.post('importPendingItems');
    },

    loadSetup: function () {
      return this.get('loadSetup');
    },
    saveSetup: function (data) {
      return this.post('saveSetup', data);
    },
    completeSetup: function (data) {
      return this.post('completeSetup', data);
    }
  };

  this.$get = ['$q', 'BooksSvc', 'BusyScreen', 'HTTPService', function ($q, BooksSvc, BusyScreen, HTTPService) {
    return Object.assign(
      HTTPService.make(this.httpServiceBase),
      this.httpServices
    );
  }];
};
